import { render, staticRenderFns } from "./BasePlanCard.vue?vue&type=template&id=72252035&scoped=true"
import script from "./BasePlanCard.vue?vue&type=script&lang=js"
export * from "./BasePlanCard.vue?vue&type=script&lang=js"
import style0 from "./BasePlanCard.vue?vue&type=style&index=0&id=72252035&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72252035",
  null
  
)

export default component.exports